<template>
  <v-container
    class="main--text"
    fluid>
    <v-layout
      justify-center>
      <v-flex
        md8
        sm10
        xs12>
        <Loading
          v-if="isLoading"/>
        <v-card
          v-else-if="teachers.length() === 0">
          <v-container>
            <v-layout>
              <v-flex>
                メッセージを送れる先生がいません。
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
        <v-card
          v-else>
          <v-container
            fluid
            grid-list-md>
            <v-layout>
              <v-flex>
                <h3>ダイレクトメッセージ</h3>
              </v-flex>
            </v-layout>
            <v-list two-line>
              <v-list-item
                v-for="(teacher, index) in teachers.get()"
                :key="index"
                style="cursor:pointer"
                @click="open(teacher)">
                <v-list-item-action>
                  <v-avatar
                    >
                    <img :src="teacher.iconUrl" alt="">
                  </v-avatar>
                </v-list-item-action>
                <v-list-item-title>
                  <span
                  class="subheading main--text">{{ teacher.fullName() }}</span>
                  <span class="main--text"> 先生</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-message-window
      v-if="selectedTeacher"
      :teacher="selectedTeacher"
      :isOpen="window"
      @open-button-click="open"
      @close-button-click="close"/>
  </v-container>
</template>

<script>
import { TeacherRepository } from "@/repository/TeacherRepository"
import { firestore } from "@/repository/client/firestore"
import VMessageWindow from "@/components/organisms/parent/VMessageWindow.vue"
import Loading from "@/components/organisms/Loading.vue"

export default {
  components: {
    VMessageWindow,
    Loading
  },
  data () {
    return {
      parent: this.$store.getters.parent,
      teachers: null,
      selectedTeacher: null,
      window: false,
      teacherRepo: null,
      isLoading: true
    }
  },
  methods: {
    async open(teacher) {
      await this.close()
      this.selectedTeacher = teacher
      this.window = true
    },
    close () {
      this.window = false
      this.selectedTeacher = null
    }
  },
  created: async function () {
    this.teacherRepo = new TeacherRepository(firestore)
    this.teachers = await this.teacherRepo.collect(this.parent.teacherIds)
    this.isLoading = false
  }
}
</script>
